import { getBarukClusterHostSuffix } from '../config/tenantHostConfig';

export const TenantAccessMode = {
  Fit: 'Fit',
  EnterpriseBasic: 'EnterpriseBasic',
  EnterpriseCustom: 'EnterpriseCustom',
} as const;

export type TenantAccessMode = (typeof TenantAccessMode)[keyof typeof TenantAccessMode];

export function isTenantAccessMode(value: unknown): value is TenantAccessMode {
  return value === TenantAccessMode.Fit
    || value === TenantAccessMode.EnterpriseBasic
    || value === TenantAccessMode.EnterpriseCustom;
}

const DNS_LABEL = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

export function normalizeSlugInput(slug: string): string {
  return slug.trim().toLowerCase();
}

export function validateTenantSlugDnsLabel(normalized: string): string | undefined {
  if (!normalized) return 'Slug é obrigatório.';
  if (normalized.length > 63) return 'Slug deve ter no máximo 63 caracteres.';
  if (!DNS_LABEL.test(normalized)) {
    return 'Slug inválido: use apenas letras minúsculas, números e hífens; não inicie nem termine com hífen.';
  }
  return undefined;
}

export function buildBarukFqdn(mode: TenantAccessMode, normalizedSlug: string): string {
  if (!normalizedSlug) return '';
  if (mode === TenantAccessMode.Fit || mode === TenantAccessMode.EnterpriseBasic) {
    return `${normalizedSlug}.${getBarukClusterHostSuffix()}`;
  }
  return '';
}

const DOMAIN_CHARS = /^[a-z0-9.-]+$/;

/** Base do slug para Enterprise Custom (primeiro rótulo após www; alinhado ao backend). */
export function deriveEnterpriseCustomSlugBaseFromDomain(domain: string): string {
  const raw = domain.trim().toLowerCase();
  if (!raw) return 'tenant';
  const parts = raw.split('.').filter(Boolean);
  if (parts.length === 0) return 'tenant';
  let i = 0;
  while (i < parts.length && parts[i] === 'www') i++;
  if (i >= parts.length) return 'tenant';
  let label = parts[i].replace(/[^a-z0-9-]+/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  if (!label) return 'tenant';
  if (label.length > 63) label = label.slice(0, 63).replace(/-+$/g, '').replace(/^-|-$/g, '');
  if (!label || !DNS_LABEL.test(label)) return 'tenant';
  return label;
}

export function validateCustomDomain(domain: string): string | undefined {
  const raw = domain.trim();
  if (!raw) return 'Domínio é obrigatório.';
  const lower = raw.toLowerCase();
  if (lower.includes(' ') || /^https?:\/\//i.test(raw)) {
    return 'Informe o domínio sem http(s):// e sem espaços.';
  }
  if (!DOMAIN_CHARS.test(lower)) {
    return 'Domínio inválido: use apenas letras minúsculas, números, hífens e pontos.';
  }
  return undefined;
}
